import {StyleSheet} from 'react-native';

import {cloudLightest, white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  content: {
    flex: 1,
    backgroundColor: cloudLightest,
    paddingBottom: 20,
  },
  emptyNotification: {
    flex: 1,
    alignItems: 'center',
    marginTop: 130,
  },
  inboxImage: {
    marginBottom: 40,
  },
  header: {
    backgroundColor: white,
    paddingBottom: 20,
  },
  heading: {
    paddingBottom: 10,
  },
  subheading: {
    paddingHorizontal: 60,
    textAlign: 'center',
  },
  loading: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
